import { Empresa } from './empresa';
import { Serializable } from './commom/serializable';

export class Grupo implements Serializable<Grupo> {
    public Id: number;
    public Descricao: string;
    public Empresa: Empresa;

    deserialize(input: Object): Grupo {
        Object.assign(this, input);

        return this;
    }

    public toString(): string {
        return `${this.Id} - ${this.Descricao}`;
    }
}


// WEBPACK FOOTER //
// ./src/entities/grupo.ts